import {Injectable, Inject} from '@angular/core';
import {ECC_BASE_URL, ECC_SERVICE_ENDPOINT_REAL_URL, ECC_SERVICE_ENDPOINT_TEST_URL} from '../shared/tokens';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class NewsMlService {

    constructor(private readonly httpClient: HttpClient,
                @Inject(ECC_BASE_URL) private readonly eccBaseUrl: string,
                @Inject(ECC_SERVICE_ENDPOINT_REAL_URL) private readonly wsRealServiceEndpoint: string,
                @Inject(ECC_SERVICE_ENDPOINT_TEST_URL) private readonly wsTestServiceEndpoint: string) {
    }

    getNewsMLMessage(useRealService: boolean): Observable<string> {
        const endpoint = useRealService ?
            this.eccBaseUrl + this.wsRealServiceEndpoint :
            this.eccBaseUrl + this.wsTestServiceEndpoint;
        return this.httpClient.get(endpoint, {responseType: 'text'});
    }
}
